// dependencies
import React from "react";
import { useIntl } from "react-intl";

// components
import Separator from "../../../components/Separator";
import Stack from "../../../components/Stack";
import {
  EstimateList,
  EstimateResume,
  EstimateAdvance,
  EstimateTotal,
} from "../../../components/Estimate";
import ActivityIndicator from "../../../components/ActivityIndicator";
import Button from "@cloudspire/legacy-resources/src/components/Button2";

// containers
import BookingAsidePrice from "./Price";

// libraries
import { generateUri } from "@cloudspire/legacy-shared/src/libraries";

// contexts
import { useRouters } from "@cloudspire/legacy-resources/src/contexts/routers";

function BookingAsideDetails(props) {
  const {
    mode,
    priceToRender,
    hasBookingEstimateList,
    hasBookingEstimateResume,
    hasBookingEstimatePrice,
    hasBookingEstimateAdvance,
    hasPricingEstimatePrice,
    type,
    list,
    total,
    resume,
    bookingEstimatePrice,
    pricingEstimatePrice,
    advance,
    pricingEstimateResponse,
    bookingEstimateResponse,
    bookingReference,
    shouldRenderBookingDetailButton,
  } = props;

  const { accountRouter } = useRouters();

  const pricingEstimateLoading =
    (!pricingEstimateResponse?.error && !pricingEstimateResponse?.data) ||
    pricingEstimateResponse?.isValidating;
  const bookingEstimateLoading =
    (!bookingEstimateResponse?.error && !bookingEstimateResponse?.data) ||
    bookingEstimateResponse?.isValidating;

  const intl = useIntl();

  return (
    <>
      {"booking" === priceToRender && !bookingEstimateLoading && (
        <>
          {hasBookingEstimateList && (
            <>
              <Stack marginTop={1} />

              <EstimateList list={list} />

              {"payment" === type && (
                <>
                  <Stack marginTop={0.5} />

                  <EstimateTotal total={total} />
                </>
              )}
            </>
          )}

          {hasBookingEstimateResume && (
            <>
              <Stack marginTop={1} />

              <EstimateResume resume={resume} />
            </>
          )}

          {shouldRenderBookingDetailButton && (
            <>
              <Stack marginTop={0.5} />
              <Button
                appearance="primary"
                to={generateUri({
                  router: accountRouter,
                  name: "App.Action.BookingCustomer.Show",
                  parameters: {
                    lang: intl.locale,
                    bookingReference: bookingReference,
                  },
                })}
                label={intl.formatMessage({
                  defaultMessage: "Voir ma réservation",
                })}
              />
            </>
          )}

          {"plain" === mode && (
            <BookingAsidePrice
              mode={mode}
              hasBookingEstimatePrice={hasBookingEstimatePrice}
              bookingEstimatePrice={bookingEstimatePrice}
              hasPricingEstimatePrice={hasPricingEstimatePrice}
              priceToRender={priceToRender}
              pricingEstimatePrice={pricingEstimatePrice}
              type={type}
            />
          )}

          {"payment" !== type &&
            "room" !== type &&
            hasBookingEstimateAdvance && (
              <>
                <Stack marginTop={1} />
                <EstimateAdvance advance={advance} />
              </>
            )}
        </>
      )}
      {"plain" === mode && "pricing" === priceToRender && (
        <>
          {pricingEstimateLoading ? (
            <>
              <Stack marginTop={0.875} />
              <ActivityIndicator />
            </>
          ) : (
            <>
              <Stack marginTop={0.875} />

              <Separator color={"#CFDADD"} />

              <BookingAsidePrice
                mode={mode}
                hasBookingEstimatePrice={hasBookingEstimatePrice}
                bookingEstimatePrice={bookingEstimatePrice}
                hasPricingEstimatePrice={hasPricingEstimatePrice}
                priceToRender={priceToRender}
                pricingEstimatePrice={pricingEstimatePrice}
                type={type}
              />
            </>
          )}
        </>
      )}
    </>
  );
}

export default BookingAsideDetails;
